export * from './angularfire2';
//# sourceMappingURL=public_api.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angularfire2/public_api.js
// module id = 303
// module chunks = 4